import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/admin/PageHeader";
import { ActivityTable } from "@/components/admin/activity/ActivityTable";
import { MasterData } from "@/components/admin/activity/MasterData";
import { BannerLibrary } from "@/components/admin/activity/BannerLibrary";

const tabCls = "rounded-full data-[state=active]:bg-[#0d3b2e] data-[state=active]:text-white";

export default function Kegiatan() {
  const [tab, setTab] = useState("upcoming");
  return (
    <div data-testid="admin-activity-page">
      <PageHeader title="Kegiatan & Agenda" subtitle="Kelola 11 kategori kegiatan, data master petugas, status, daftar hadir, dan laporan" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-full bg-white border border-emerald-900/10 p-1 h-auto flex-wrap">
          <TabsTrigger value="upcoming" className={tabCls} data-testid="activity-tab-upcoming">Kegiatan Mendatang</TabsTrigger>
          <TabsTrigger value="history" className={tabCls} data-testid="activity-tab-history">Riwayat</TabsTrigger>
          <TabsTrigger value="master" className={tabCls} data-testid="activity-tab-master">Data Master Petugas</TabsTrigger>
          <TabsTrigger value="banner" className={tabCls} data-testid="activity-tab-banner">Perpustakaan Banner</TabsTrigger>
        </TabsList>
        <TabsContent value="upcoming" className="mt-6"><ActivityTable mode="upcoming" /></TabsContent>
        <TabsContent value="history" className="mt-6"><ActivityTable mode="past" /></TabsContent>
        <TabsContent value="master" className="mt-6"><MasterData /></TabsContent>
        <TabsContent value="banner" className="mt-6"><BannerLibrary /></TabsContent>
      </Tabs>
    </div>
  );
}
